import React, { Component, useEffect, useState } from 'react'
import shortid from "shortid";
import MyComponent from '../components/MyComponent';

const PluginSlotContainer=({ containerObject, templateName, contentId, dataZone })=> {
    const [windowWidth, setWindowWidth] = useState(650);
    const desktopImage = containerObject.attributes?.backgroundImageUrl ? containerObject.attributes.backgroundImageUrl :  (containerObject.backgroundImage ? containerObject.backgroundImage :"")
    
    const mobileImage = containerObject.attributes?.mobileBackgroundImageUrl	?   containerObject.attributes.mobileBackgroundImageUrl : (containerObject.mobileBackgroundImage	 ?  containerObject.mobileBackgroundImage	 :(desktopImage ? desktopImage :""))
    var backgroundImageUrl =""
    if(windowWidth){
        backgroundImageUrl = windowWidth >= 650 ? desktopImage : mobileImage;
    }
    

    useEffect(() => {
        const handleWindowResize = () => {
            setWindowWidth(window.innerWidth);
        };
        
        window.addEventListener('resize', handleWindowResize);

        return () => {
            window.removeEventListener('resize', handleWindowResize);
        }
    }, []);
    //let urlStyle = `url(${containerObject.backgroundImage?containerObject.backgroundImage:""})`
    //const styleObj = {backgroundImage :backgroundImageUrl ? `url(${backgroundImageUrl})` :""}
    return (
        <div className="containerWarp"     style={{backgroundImage :backgroundImageUrl ? `url(${backgroundImageUrl})` :""}} data-cont-id={containerObject ? containerObject.contentId : ""} data-zone="ContentFolderZone" data-zone-id="Content Rule Zone" data-page-id={containerObject ? containerObject.containerContentId : ""}>
            <div className="primary-zone" data-zone="ContentFolderZone" >
                <div className={"row m-0 "} data-page-id={containerObject ? containerObject.contentId : ""} data-id="zone" data-zone="ContentFolderZone"
                    plugin-name={containerObject &&  containerObject.contents && containerObject.contents.ContentFolderZone[0] &&
                             containerObject.contents.ContentFolderZone[0].attributes && containerObject.contents.ContentFolderZone[0].attributes.folderName} >
                    <div className="container-fluid justify-content-around gx-0 px-0" 
                    
                    data-page-id={containerObject ? containerObject.contentId : ""} data-id="zone" data-zone="ContentFolderZone">
                       {/* <NavbarHeader/>          */}         
                        {containerObject && containerObject.contents && containerObject.contents.ContentFolderZone.map(content => { 
                            let contentFolderZoneType = content['@type'];

                            return (                            
                            <MyComponent type={contentFolderZoneType} key={shortid.generate()} containerObject={content} contentId={contentId} dataZone={"ContentFolderZone"} templateName={contentFolderZoneType} parentAttributes={containerObject.attributes? containerObject.attributes :""}  />
                       
						)
                        }
                        )} 
                    </div>
                </div>
            </div>
        </div>

    )

}
export default PluginSlotContainer;
